// PrivateRoute.jsx
import { Navigate } from "react-router-dom";

export default function PrivateRoute({ children }) {
  const isLoggedInF = !!localStorage.getItem("memberflyer"); // or sessionStorage

  return isLoggedInF ? children : <Navigate to="/flyer-login" replace />;
}